import axios from "axios";
import Cookies from "js-cookie";
import {
	handleAuthFailure,
	isAuthFailurePayload,
} from "../Utility/authSession";

const api = axios.create({
	// baseURL: "https://localhost:7115",
	baseURL: "https://uat.xprssurvey.com",
	// baseURL: "http://localhost:9080/",
	headers: {
		"Content-Type": "application/json",
	},
});

api.interceptors.request.use(
	(config) => {
		const token = Cookies.get("JWTToken");

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}

		return config;
	},
	(error) => Promise.reject(error),
);

api.interceptors.response.use(
	(response) => {
		const { data, config, status } = response;
		if (isAuthFailurePayload(data, status)) {
			handleAuthFailure(data?.message, config?.url);
			return Promise.reject(
				new axios.AxiosError(
					data?.message || "Unauthorized",
					axios.AxiosError.ERR_BAD_REQUEST,
					config,
					response.request,
					response,
				),
			);
		}
		return response;
	},
	(error) => {
		const status = error.response?.status;
		const data = error.response?.data;
		const url = error.config?.url;

		if (isAuthFailurePayload(data, status)) {
			handleAuthFailure(data?.message, url);
		}

		return Promise.reject(error);
	},
);

export default api;
